<!-- 
create by melody on 2018/11/1 
description:按钮管理页面 
-->
<template>
    <div>
       <page-header :title="title"></page-header>
       <div class="search-container">
            <el-form label-width="100px">
                <el-row>
                    <el-col :xl="8" :lg="10" :md="12">
                        <el-form-item :label="$t('m.firstMenu')" style="width: 400px;">
                            <el-select                                 
                                v-model="selectFirst"
                                v-on:change="getFirst($event)">
                                <el-option
                                    v-for="(item,index) in firsts"
                                    :key="index"
                                    :label="item.menuName"
                                    :value="item.menuId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xl="8"  :lg="10"  :md="12">
                        <el-form-item :label="$t('m.secondMenu')" v-if="seconds && seconds.length" style="width: 400px;">
                            <el-select 
                                v-model="selectSecond"
                                v-on:change="getSecond($event)">
                                <el-option
                                    v-for="(item,index) in seconds"
                                    :key="index"
                                    :label="item.menuName"
                                    :value="item.menuId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="table-container">
            <el-button type="primary" plain icon="el-icon-plus" @click="handleClick('add')"> {{$t('m.add')}} </el-button>
            <el-table
                ref="multipleTable"
                :data="tableData"
                stripe
                tooltip-effect="dark"
                style="width: 100%;margin: 24px 0"
                >
                <el-table-column
                    type="index"
                    width="55">
                </el-table-column>
                <el-table-column
                    :label="$t('m.buttonName')"
                    prop="buttonName">
                </el-table-column>
                <el-table-column
                    prop="buttonCode"
                    :label="$t('m.buttonCode')">
                </el-table-column>
                <el-table-column
                    prop="enableFlag"
                    :label="$t('m.enableFlag')"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
                    </template>
                </el-table-column>
                <el-table-column 
                    fixed="right"
                    width="150" 
                    :label="$t('m.operation')">
                    <template slot-scope="scope">
                        <el-button
                            icon="el-icon-edit-outline" 
                            plain
                            size="mini"
                            @click="handleClick('modify', scope.row)"></el-button>
                        <el-button
                            icon="el-icon-delete"
                            plain
                            size="mini"
                            type="danger"
                            @click="handleDelete('single',scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            :title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify') :''"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item :label="$t('m.buttonType')" prop="buttonCode" style="width: 100%">
                        <el-select v-model="form.buttonCode" @change="selectChange">
                            <el-option v-for="(item, index) in buttonList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('m.enableFlag')" prop="enableFlag" style="width: 100%">
                        <el-radio-group  v-model="form.enableFlag">
                            <el-radio :label="true" checked>{{$t('m.enable')}}</el-radio>
                            <el-radio :label="false">{{$t('m.disable')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span v-if="operateType!='view'" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.SYSTEM_MANAGE'),
                thirdTitle: this.$t('m.BUTTON_MANAGE')
            },
            firsts:[],
            seconds: [],
            selectFirst: '',
            selectSecond: '',
            form: {     //弹框内容
                buttonId: '',
                buttonName: '',
                buttonCode: '',
                enableFlag: '',
                menuId: ''
            },
            rules: this.$ruleApi.getRule('button'),
            tableData: [],  //表数据
            dialogVisible: false,   //控制弹框显示与隐藏
            operateType: '',    //操作类型 add新增 modify修改 view查看
            menuIdFlag: '',
            buttonList: [
            {
                label: '新增',
                value: '1'
            },
            {
                label: '修改',
                value: '2'
            },
            {
                label: '删除',
                value: '3'
            },
            {
                label: '批量删除',
                value: '4'
            },
            {
                label: '下载模板',
                value: '5'
            },
            {
                label: '上传',
                value: '6'
            },
            {
                label: '导出',
                value: '7'
            }],
            addDisable: false
        }
    },
    methods: {
        selectChange(val) {
            let obj = {};
            obj = this.buttonList.find((item)=>{
                return item.value === val;
            });
            this.form.buttonName = obj.label
        },
        //点击一级菜单，获得二级菜单
        getFirst (first) {
            let tempCity = []             
            this.seconds = [] 
            this.selectSecond = ''         
            for (var val of this.firsts) {
                if (first == val.menuId) {
                    tempCity = val.childrenList
                }
             }
            //如果选择的一级菜单有子菜单选择二级菜单  没有则查询该菜单下的按钮
            if (tempCity) {
                this.seconds = tempCity
            } else {
                this.getDemoList()
            }
            
        },
        getSecond(second) {
            this.getDemoList()
        },
        getDemoList() {
            this.menuIdFlag = this.selectSecond ? this.selectSecond : this.selectFirst
            if(!this.menuIdFlag) {
                this.$message.info(this.$t('m.chooseMenu'))
                return
            }
            this.$commonFunc.commonRequest('get', '/system/buttonManage/list/menuId', 'getButtonList', {menuId: this.menuIdFlag})
            .then(res=>{
                if(!res.obj) {
                    this.$message.info(this.$t('m.menuNoBtn'))
                    this.tableData = []
                } else {
                    this.tableData = res.obj
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        
        addDemo() {
            this.$commonFunc.commonRequest('post', '/system/buttonManage/added', 'addButton', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
            this.$commonFunc.commonRequest('post', '/system/buttonManage/modified', 'modifyButton', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            //如果操作已有数据
            if(row) {
                this.dialogVisible = true
                this.form = JSON.parse(JSON.stringify(row))            
            } else {
                this.menuIdFlag = this.selectSecond ? this.selectSecond : this.selectFirst
                if(!this.menuIdFlag) {
                     this.$message.info(this.$t('m.chooseMenu'))
                } else {
                    this.dialogVisible = true
                    this.form = {
                        buttonName: '',
                        buttonCode: '',
                        enableFlag: true,
                        menuId: this.menuIdFlag
                    }
                }
            }
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                        this.addDisable = true
                        this.addDemo()
                    } else {
                        this.modifyDemo()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                //单个删除
                if(type == 'single') {
                    this.$commonFunc.commonRequest('get', '/system/buttonManage/deleted', 'deleteButton', {buttonId: row.buttonId})
                    .then(res=>{
                        this.$message.success(this.$t('m.deleteSuccess'));
                        this.getDemoList()
                    })
                } 
            })
        },
        getResorceTree() {
            this.$commonFunc.commonRequest('get', '/system/menuManage/list')
            .then(res=>{
                this.firsts = res.obj
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
    },
    mounted() {
        this.getResorceTree()
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/sys/ButtonManage.vue